module.exports = __webpack_public_path__ + "img/frame (276).211acb82.jpg";